import React from "react";
import MaterialTable from "material-table";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import SettingsIcon from "@material-ui/icons/Settings";
import {
  useStyles,
  getEditableComponent,
  getOptions,
  formatRoleData,
} from "../../helpers/DataTable";
import {getOrderedPeopleData, getPeopleColumns} from "helpers/PeopleDataTable";
import {tableIcons} from "../../components/ReusableComponents/DatatableIconsComponent";
import {RolesTableComponent, TeamsTableComponent} from "../../components";

export default function PeopleDatatableComponent(props) {
  const {
    nodes,
    data: people,
    isLoading,
    handlePeopleChange,
    handlePeopleRefresh,
  } = props;
  const classes = useStyles();
  let data = getOrderedPeopleData(people);
  const columns = getPeopleColumns();

  const handleRolesChange = (updatedRoles, rowData) => {
    const people = [...data];
    rowData.roles = formatRoleData(updatedRoles);
    const index = rowData.tableData.id;
    people[index] = rowData;
    handlePeopleChange([...people]);
  };

  const handleTeamsChange = (updatedTeams, rowData) => {
    const people = [...data];
    rowData.teams = formatRoleData(updatedTeams);
    const index = rowData.tableData.id;
    people[index] = rowData;
    handlePeopleChange([...people]);
  };

  return (
    <main className={classes.content}>
      <Container className={classes.container}>
        {/* JSON viewer conatainer*/}
        <Grid container className={classes.viewerSettings}>
          <Grid item xs={12} md={8} lg={12}>
            <div style={{maxWidth: "100%"}}>
              <MaterialTable
                isLoading={isLoading}
                icons={tableIcons}
                columns={columns}
                data={data}
                title={
                  <div className={classes.iconContainer}>
                    <SettingsIcon />
                    <h2 className={classes.headerText}>People </h2>
                  </div>
                }
                options={getOptions}
                editable={getEditableComponent(data, handlePeopleChange)}
                actions={[
                  {
                    icon: "refresh",
                    tooltip: "Refresh Data",
                    isFreeAction: true,
                    onClick: () => handlePeopleRefresh(),
                  },
                ]}
                detailPanel={(rowData) => {
                  return (
                    <div>
                      {/** Roles */}
                      <RolesTableComponent
                        roles={formatRoleData(
                          rowData.roles && rowData.roles.length
                            ? rowData.roles
                            : []
                        )}
                        nodes={nodes}
                        rowData={rowData}
                        handleRolesChange={handleRolesChange}
                      />

                      {/** Teams */}
                      <TeamsTableComponent
                        teams={formatRoleData(
                          rowData.teams && rowData.teams.length
                            ? rowData.teams
                            : []
                        )}
                        nodes={nodes}
                        rowData={rowData}
                        handleTeamsChange={handleTeamsChange}
                      />
                    </div>
                  );
                }}
              />
            </div>
          </Grid>
        </Grid>
      </Container>
    </main>
  );
}
